define( function() {
	"use strict";

	return function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};

} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/var/isWindow.js
// module id = 116
// module chunks = 0